/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Card, Row, Col, Space, Flex, Table, Input, InputNumber,
  Select, DatePicker, Button, Typography, Tabs, Tag, message, TimePicker, Checkbox, Tooltip, Modal, Divider,
} from "antd";
import { SaveOutlined, ArrowLeftOutlined, DeleteOutlined, PrinterOutlined, PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import GoodsReceiptService from "../../../service/ERP/GoodsReceipt.service";
import OptionService from "../../../service/ERP/Options.service";
import { Authenticate } from "../../../service/Authenticate.service";
import { ButtonAttachFilesGR } from "../../../components/button";
import { ModalUnit } from "../../../components/modal/ERP/unit/modal-unit.js";

const grService = GoodsReceiptService();
const optionService = OptionService();
const authService = Authenticate();

const currentUserName = () => {
  const u = authService.getUserInfo();
  return u ? `${u.firstname || ""} ${u.lastname || ""}`.trim() : "";
};
const gotoFrom = "/ERP/goods-receipt";

const MAT_TYPE_OPTIONS = ["สด", "แช่แข็ง", "แห้ง"].map((v) => ({ label: v, value: v }));
/* หน่วยบรรจุดึงจากทะเบียนหน่วย er_unit (options-unit.php) ไม่ได้ fix ไว้ในโค้ดแล้ว */
const CONCLUDE_OPTIONS = [
  { label: "Accept", value: "accept" },
  { label: "Reject", value: "reject" },
];
const YESNO = [
  { label: "มี", value: 1 },
  { label: "ไม่มี", value: 0 },
];
const PASSFAIL = [
  { label: "ผ่าน", value: 1 },
  { label: "ไม่ผ่าน", value: 0 },
];
const GOODBAD = [
  { label: "ดี", value: 1 },
  { label: "ไม่ดี", value: 0 },
];

/* สารเคมี : รหัสสินค้าขึ้นต้นด้วย IG7 → ใช้ฟอร์ม FM.QA.15 แทน FM.QA.12 */
const isChemical = (d) => String(d?.stcode || "").toUpperCase().startsWith("IG7");

/* ภาชนะบรรจุ/บรรจุภัณฑ์ : รหัสขึ้นต้น PK หรือ PC → ใช้ฟอร์ม FM.WH.13 */
const isPacking = (d) => {
  const p = String(d?.stcode || "").toUpperCase().slice(0, 2);
  return p === "PK" || p === "PC";
};

/* ตัวเลือกแบบเครื่องหมาย / กับ X ของฟอร์ม FM.WH.13 */
const NORMAL_ABNORMAL = [
  { label: "ปกติ ( / )", value: 1 },
  { label: "ผิดปกติ ( X )", value: 0 },
];
const CLEAN_UNCLEAN = [
  { label: "สะอาด ( / )", value: 1 },
  { label: "ไม่สะอาด ( X )", value: 0 },
];
/* หมายเหตุ : ใช้ polarity เดียวกับ IG (0 = ไม่พบ/ไม่มี) เพราะ prefill จาก GR ตั้งค่ามาเป็น 0
   บนฟอร์มพิมพ์ 0 จะแสดงเป็น "/" (ปกติ) และ 1 แสดงเป็น "X" (ผิดปกติ) */
const NONE_FOUND = [
  { label: "ไม่พบ ( / )", value: 0 },
  { label: "พบ ( X )", value: 1 },
];

export default function QcInspection() {
  const navigate = useNavigate();
  const location = useLocation();
  const { config } = location.state || {};
  const grcode = config?.code;

  const [loading, setLoading] = useState(false);
  const [gr, setGr] = useState({});
  const [head, setHead] = useState({ inspector: "", inspect_date: dayjs() });
  const [rowsRM, setRowsRM] = useState([]);
  const [rowsIG, setRowsIG] = useState([]);
  /* สารเคมี : รหัสสินค้าขึ้นต้น IG7 → ใช้ฟอร์ม FM.QA.15 (ใน DB ยังเก็บ report_type = 'IG') */
  const [rowsCM, setRowsCM] = useState([]);
  /* บรรจุภัณฑ์ : รหัสขึ้นต้น PK/PC → ใช้ฟอร์ม FM.WH.13 (ใน DB ยังเก็บเป็น 'IG') */
  const [rowsPK, setRowsPK] = useState([]);
  const [activeTab, setActiveTab] = useState("rm");

  /* ---------- หน่วยบรรจุ : ทะเบียนหน่วย er_unit + modal เพิ่ม/เลือกหน่วย ---------- */
  const [unitOptions, setUnitOptions] = useState([]);
  const [openUnitModal, setOpenUnitModal] = useState(false);
  /* แถวที่กดเปิด modal ไว้ เพื่อเติมค่าให้ถูกช่องหลังเลือกหน่วย */
  const [unitTarget, setUnitTarget] = useState(null);

  const loadUnits = () => {
    optionService
      .optionsUnit()
      .then((res) => {
        const list = res.data?.data || [];
        setUnitOptions(list.map((u) => ({ label: u.label ?? u.value, value: u.value })));
      })
      .catch(() => {});
  };

  useEffect(() => {
    loadUnits();
  }, []);

  const handleUnitChosen = (v) => {
    const name = v?.unitname || v?.value;
    loadUnits();
    if (name && unitTarget) {
      updateRow(unitTarget.type, unitTarget.key, "pack_unit", name);
    }
  };
  const [coaAttached, setCoaAttached] = useState(false);
  /* มีการแก้ไขที่ยังไม่ได้บันทึกหรือยัง — ใช้เตือนก่อนพิมพ์ฟอร์ม */
  const [dirty, setDirty] = useState(false);
  const gridRef = useRef(null);

  /* Enter → ไปช่องถัดไปในตาราง (เฉพาะหน้านี้) */
  const handleGridKeyDown = (e) => {
    if (e.key !== "Enter") return;
    if (e.target.tagName === "TEXTAREA") return;
    // ถ้ามี dropdown ของ Select/DatePicker เปิดอยู่ ให้ปล่อยพฤติกรรมเดิม
    if (document.querySelector(".ant-select-open, .ant-picker-dropdown:not(.ant-picker-dropdown-hidden)")) return;
    const root = gridRef.current;
    if (!root) return;
    const focusables = Array.from(
      root.querySelectorAll("input:not([disabled]):not([type=hidden])")
    ).filter((el) => el.offsetParent !== null);
    const idx = focusables.indexOf(e.target);
    if (idx > -1 && idx < focusables.length - 1) {
      e.preventDefault();
      const next = focusables[idx + 1];
      next.focus();
      if (typeof next.select === "function") next.select();
    }
  };

  useEffect(() => {
    if (!grcode) {
      navigate(gotoFrom, { replace: true });
      return;
    }
    load();
  }, []);

  const load = async () => {
    setLoading(true);
    try {
      const res = await grService.qcGet(grcode);
      const { gr: g, qc, detail } = res.data?.data || {};
      setGr(g || {});
      setCoaAttached(Number(g?.coa_attached || 0) > 0);
      setHead({
        inspector: qc?.inspector || currentUserName(),
        remark: qc?.remark || "",
        inspect_date: qc?.inspect_date ? dayjs(qc.inspect_date) : (g?.grdate ? dayjs(g.grdate) : dayjs()),
        /* วันที่ส่งรายงานผลตรวจ — ไม่ตั้งค่าเริ่มต้นให้ ปล่อยว่างจนกว่าจะส่งจริง
           ถ้าว่างแล้วพิมพ์ออกมา จะได้เส้นประไว้เขียนมือ */
        report_sent_date: qc?.report_sent_date ? dayjs(qc.report_sent_date) : null,
      });
      const norm = (d, i) => ({
        key: d.id ?? `${d.report_type}-${i}-${d.stcode}-${d.lot_no || ""}`,
        ...d,
        inspect_time: d.inspect_time || null,
        production_date: d.production_date ? dayjs(d.production_date) : null,
        expiry_date: d.expiry_date ? dayjs(d.expiry_date) : null,
      });
      const all = (detail || []).map(norm);
      const rm = all.filter((d) => d.report_type !== "IG").map((d, i) => ({ ...d, seq: i + 1 }));
      /* IG7 = สารเคมี → FM.QA.15 , PK/PC = ภาชนะบรรจุ-บรรจุภัณฑ์ → FM.WH.13 */
      const ig = all
        .filter((d) => d.report_type === "IG" && !isChemical(d) && !isPacking(d))
        .map((d, i) => ({ ...d, seq: i + 1 }));
      const cm = all
        .filter((d) => d.report_type === "IG" && isChemical(d))
        .map((d, i) => ({ ...d, seq: i + 1 }));
      const pk = all
        .filter((d) => d.report_type === "IG" && isPacking(d))
        .map((d, i) => ({ ...d, seq: i + 1 }));
      setRowsRM(rm);
      setRowsIG(ig);
      setRowsCM(cm);
      setRowsPK(pk);
      setActiveTab(
        rm.length > 0 ? "rm" : ig.length > 0 ? "ig" : cm.length > 0 ? "cm" : "pk"
      );
      setDirty(false);
    } catch (err) {
      message.error(err?.response?.data?.message || "โหลดข้อมูลไม่สำเร็จ");
    } finally {
      setLoading(false);
    }
  };

  /* หลังปิด Drawer แนบไฟล์ → เช็คสถานะ COA ใหม่ (ไม่ล้างข้อมูลที่กรอกค้างไว้) */
  const refreshCoaStatus = async () => {
    try {
      const res = await grService.qcGet(grcode);
      const g = res.data?.data?.gr;
      setCoaAttached(Number(g?.coa_attached || 0) > 0);
    } catch {}
  };

  const setterOf = (type) =>
    type === "RM" ? setRowsRM
      : type === "CM" ? setRowsCM
      : type === "PK" ? setRowsPK
      : setRowsIG;

  const updateRow = (type, key, field, value) => {
    const setter = setterOf(type);
    setter((prev) => prev.map((r) => (r.key === key ? { ...r, [field]: value } : r)));
    setDirty(true);
  };

  const deleteRow = (type, key) => {
    const setter = setterOf(type);
    setter((prev) => prev.filter((r) => r.key !== key).map((r, i) => ({ ...r, seq: i + 1 })));
    setDirty(true);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const fmtDate = (d) => (d ? dayjs(d).format("YYYY-MM-DD") : null);
      const fmtTime = (t) => (t ? (dayjs.isDayjs(t) ? dayjs(t).format("HH:mm") : t) : null);
      const pack = (rows, type) =>
        rows.map((r) => ({
          ...r,
          report_type: type,
          inspect_time: fmtTime(r.inspect_time),
          production_date: fmtDate(r.production_date),
          expiry_date: fmtDate(r.expiry_date),
          // COA อ้างอิงไฟล์แนบของใบรับสินค้า ไม่ให้แก้ไขในตาราง
          ...(type === "IG" ? { coa_status: coaAttached ? 1 : 0 } : {}),
        }));
      const payload = {
        header: {
          grcode,
          inspect_date: fmtDate(head.inspect_date),
          report_sent_date: fmtDate(head.report_sent_date),
          inspector: head.inspector,
          qc_sup: null,
          pd_sup: null,
          remark: head.remark,
        },
        /* CM บันทึกเป็น report_type = 'IG' เหมือนเดิม แยกด้วยรหัสสินค้าตอนแสดงผล */
        detail: [
          ...pack(rowsRM, "RM"),
          ...pack(rowsIG, "IG"),
          ...pack(rowsCM, "IG"),
          ...pack(rowsPK, "IG"),
        ],
      };
      await grService.qcSave(payload);
      message.success("บันทึกผลตรวจรับสำเร็จ");
      setDirty(false);
      return true;
    } catch (err) {
      message.error(err?.response?.data?.message || "บันทึกไม่สำเร็จ");
      return false;
    } finally {
      setLoading(false);
    }
  };

  /* ย้อนกลับ : เตือนถ้ายังมีการแก้ไขที่ไม่ได้บันทึก */
  const handleBack = () => {
    if (!dirty) {
      navigate(gotoFrom, { replace: true });
      return;
    }
    Modal.confirm({
      title: "ข้อมูลมีการแก้ไข",
      content: "ต้องการบันทึกผลตรวจก่อนออกจากหน้านี้หรือไม่?",
      okText: "บันทึกแล้วออก",
      cancelText: "ออกโดยไม่บันทึก",
      onOk: async () => {
        const ok = await handleSave();
        if (ok) navigate(gotoFrom, { replace: true });
      },
      onCancel: () => navigate(gotoFrom, { replace: true }),
    });
  };

  const openPrintWindow = () => {
    window.open(`/gr-qc-print/${encodeURIComponent(grcode)}`, "_blank");
  };

  /* กดพิมพ์ฟอร์ม : ถ้ายังมีการแก้ไขที่ไม่ได้บันทึก ให้ถามก่อน */
  const handlePrint = () => {
    if (!dirty) {
      openPrintWindow();
      return;
    }
    Modal.confirm({
      title: "ข้อมูลมีการแก้ไข",
      content: "ต้องการบันทึกผลตรวจก่อนพิมพ์หรือไม่? ถ้าไม่บันทึก เอกสารที่พิมพ์จะเป็นข้อมูลชุดเดิม",
      okText: "บันทึกแล้วพิมพ์",
      cancelText: "พิมพ์โดยไม่บันทึก",
      onOk: async () => {
        const ok = await handleSave();
        if (ok) openPrintWindow();
      },
      onCancel: () => openPrintWindow(),
    });
  };

  /* ---------- คอลัมน์ร่วม ---------- */
  const timeCol = (type) => ({
    title: "เวลา", dataIndex: "inspect_time", width: 90, align: "center",
    render: (v, r) => (
      <TimePicker
        format="HH:mm" size="small" style={{ width: "100%" }}
        value={v ? dayjs(v, "HH:mm") : null}
        onChange={(t) => updateRow(type, r.key, "inspect_time", t ? t.format("HH:mm") : null)}
      />
    ),
  });
  const nameCol = (type, title) => ({
    title, dataIndex: "stname", width: 180,
    render: (v) => <span>{v}</span>,
  });
  /* ช่องหน่วย : ตัวเลือกมาจาก er_unit และมีปุ่มเปิด modal เพิ่มหน่วยใหม่ท้ายรายการ
     ค่าเดิมที่ไม่มีในทะเบียนยังแสดงได้ตามปกติ */
  const unitCol = (type, title = "หน่วย", width = 100) => ({
    title,
    dataIndex: "pack_unit",
    width,
    align: "center",
    render: (v, r) => (
      <Select
        size="small"
        style={{ width: "100%" }}
        options={unitOptions}
        value={v || undefined}
        placeholder="เลือกหน่วย"
        showSearch
        optionFilterProp="label"
        onChange={(val) => updateRow(type, r.key, "pack_unit", val)}
        dropdownRender={(menu) => (
          <>
            {menu}
            <Divider style={{ margin: "4px 0" }} />
            <Button
              type="link"
              size="small"
              icon={<PlusOutlined />}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => {
                setUnitTarget({ type, key: r.key });
                setOpenUnitModal(true);
              }}
            >
              เพิ่ม / จัดการหน่วย
            </Button>
          </>
        )}
      />
    ),
  });

  const selCol = (type, dataIndex, title, options, width = 100) => ({
    title, dataIndex, width, align: "center",
    render: (v, r) => (
      <Select
        size="small" style={{ width: "100%" }} options={options}
        value={v} onChange={(val) => updateRow(type, r.key, dataIndex, val)}
      />
    ),
  });
  const numCol = (type, dataIndex, title, width = 90) => ({
    title, dataIndex, width, align: "right",
    render: (v, r) => (
      <InputNumber
        size="small" min={0} style={{ width: "100%" }}
        value={v} onChange={(val) => updateRow(type, r.key, dataIndex, val)}
      />
    ),
  });
  const dateCol = (type, dataIndex, title, width = 130) => ({
    title, dataIndex, width, align: "center",
    render: (v, r) => (
      <DatePicker
        size="small" format="DD/MM/YYYY" style={{ width: "100%" }}
        value={v ? dayjs(v) : null}
        onChange={(d) => updateRow(type, r.key, dataIndex, d)}
      />
    ),
  });
  const textCol = (type, dataIndex, title, width = 130) => ({
    title, dataIndex, width,
    render: (v, r) => (
      <Input size="small" value={v} onChange={(e) => updateRow(type, r.key, dataIndex, e.target.value)} />
    ),
  });
  const delCol = (type) => ({
    title: "", width: 45, align: "center",
    render: (_, r) => (
      <Button size="small" danger icon={<DeleteOutlined />} onClick={() => deleteRow(type, r.key)} />
    ),
  });

  /* Lot no. แบบรวม : "<express lot>/<lot ที่ระบบออกให้>" */
  const lotDisplay = (r) => {
    const ex = (r?.express_lot || "").trim();
    const lot = r?.lot_no || "";
    if (!ex) return lot || "-";
    return `${ex}/${lot}`;
  };

  /* ฝั่ง IG ใช้ internal_lot เป็นเลข lot ของระบบ */
  const internalLotDisplay = (r) => {
    const ex = (r?.express_lot || "").trim();
    const lot = r?.internal_lot || r?.lot_no || "";
    if (!ex) return lot || "-";
    return `${ex}/${lot}`;
  };

  const seqCol = { title: "ลำดับ", dataIndex: "seq", width: 55, align: "center" };

  /* ---------- ฟอร์ม RM (FM.QA.11) ---------- */
  const rmColumns = [
    seqCol,
    timeCol("RM"),
    nameCol("RM", "ชื่อวัตถุดิบ พืช/ผัก"),
    selCol("RM", "mat_type", "ลักษณะ", MAT_TYPE_OPTIONS, 100),
    selCol("RM", "transfer_ok", "สภาพขนส่ง", PASSFAIL, 100),
    selCol("RM", "packaging_ok", "สภาพบรรจุ", GOODBAD, 100),
    numCol("RM", "def_spoiled", "เน่าเสีย", 80),
    numCol("RM", "def_insect", "ร่องรอยแมลง", 90),
    numCol("RM", "def_foreign", "สิ่งแปลกปลอม", 90),
    numCol("RM", "def_other", "อื่นๆ", 70),
    numCol("RM", "total_qty", "จำนวน", 90),
    unitCol("RM"),
    numCol("RM", "total_weight", "น้ำหนัก(Kg)", 100),
    textCol("RM", "express_lot", "Express Lot", 120),
    {
      title: "Lot no.",
      dataIndex: "lot_no",
      width: 170,
      align: "center",
      render: (_, r) => <span>{lotDisplay(r)}</span>,
    },
    selCol("RM", "conclude", "สรุปผล", CONCLUDE_OPTIONS, 100),
    textCol("RM", "correction", "การแก้ไข", 130),
    delCol("RM"),
  ];

  /* ---------- ฟอร์ม IG (FM.QA.12) ---------- */
  const igColumns = [
    seqCol,
    timeCol("IG"),
    nameCol("IG", "ชื่อสารเคมี-ส่วนผสม"),
    selCol("IG", "transfer_ok", "สภาพขนส่ง", PASSFAIL, 100),
    selCol("IG", "packaging_ok", "สภาพบรรจุ", GOODBAD, 100),
    selCol("IG", "foreign_matter", "สิ่งแปลกปลอม", YESNO, 100),
    selCol("IG", "pest_insect", "ร่องรอยสัตว์/แมลง", YESNO, 120),
    numCol("IG", "total_qty", "จำนวน", 90),
    unitCol("IG"),
    numCol("IG", "total_weight", "น้ำหนัก(Kg)", 100),
    dateCol("IG", "production_date", "วันที่ผลิต", 130),
    dateCol("IG", "expiry_date", "วันหมดอายุ", 130),
    {
      title: "COA",
      dataIndex: "coa_status",
      width: 90,
      align: "center",
      render: () => (
        <Tooltip
          title={
            coaAttached
              ? "มีไฟล์ COA แนบไว้แล้ว"
              : "ยังไม่มีไฟล์ COA แนบ — กดปุ่ม \"แนบไฟล์\" ด้านบนเพื่อแนบ"
          }
        >
          <Checkbox checked={coaAttached} disabled />
        </Tooltip>
      ),
    },
    textCol("IG", "supplier_lot", "Supplier COA/Lot", 130),
    textCol("IG", "express_lot", "Express Lot", 130),
    {
      title: "Internal Lot No.",
      dataIndex: "internal_lot",
      width: 170,
      align: "center",
      render: (_, r) => <span>{internalLotDisplay(r)}</span>,
    },
    selCol("IG", "conclude", "สรุปผล", CONCLUDE_OPTIONS, 100),
    textCol("IG", "correction", "การแก้ไข", 130),
    delCol("IG"),
  ];

  /* ---------- ฟอร์ม CM สารเคมี IG7* (FM.QA.15) ---------- */
  const cmColumns = [
    seqCol,
    nameCol("CM", "ชื่อสารเคมี"),
    selCol("CM", "transfer_ok", "สภาพขนส่ง", PASSFAIL, 110),
    selCol("CM", "packaging_ok", "สภาพการบรรจุ", GOODBAD, 110),
    numCol("CM", "total_qty", "จำนวนทั้งหมด", 110),
    unitCol("CM"),
    numCol("CM", "total_weight", "น้ำหนักรวม (Kg)", 110),
    dateCol("CM", "production_date", "วันที่ผลิต", 130),
    dateCol("CM", "expiry_date", "วันหมดอายุ", 130),
    {
      title: "COA",
      dataIndex: "coa_status",
      width: 90,
      align: "center",
      render: () => (
        <Tooltip
          title={
            coaAttached
              ? "มีไฟล์ COA แนบไว้แล้ว"
              : "ยังไม่มีไฟล์ COA แนบ — กดปุ่ม \"แนบไฟล์\" ด้านบนเพื่อแนบ"
          }
        >
          <Checkbox checked={coaAttached} disabled />
        </Tooltip>
      ),
    },
    textCol("CM", "supplier_lot", "Supplier COA/Lot", 130),
    textCol("CM", "express_lot", "Express Lot", 130),
    {
      title: "Lot No.",
      dataIndex: "internal_lot",
      width: 170,
      align: "center",
      render: (_, r) => <span>{internalLotDisplay(r)}</span>,
    },
    selCol("CM", "conclude", "สรุปผลการตรวจรับ", CONCLUDE_OPTIONS, 120),
    textCol("CM", "correction", "หมายเหตุ / การแก้ไข", 150),
    delCol("CM"),
  ];

  /* ---------- ฟอร์ม PK ภาชนะบรรจุ/บรรจุภัณฑ์ PK*-PC* (FM.WH.13) ---------- */
  const pkColumns = [
    seqCol,
    { title: "รหัสสินค้า", dataIndex: "stcode", width: 100, align: "center" },
    nameCol("PK", "ชื่อรายการ"),
    unitCol("PK", "Unit (กล่อง,พาเลท)", 120),
    numCol("PK", "total_qty", "Total (กล่อง,พาเลท,แพค)", 130),
    numCol("PK", "total_weight", "Total Quantity (จำนวนทั้งหมด)", 140),
    selCol("PK", "transfer_ok", "สภาพภาชนะขนส่ง", NORMAL_ABNORMAL, 130),
    selCol("PK", "packaging_ok", "ความสะอาด", CLEAN_UNCLEAN, 130),
    selCol("PK", "def_foreign", "การฉีกขาดของภาชนะ/บรรจุภัณฑ์", NONE_FOUND, 140),
    selCol("PK", "def_other", "กลิ่นผิดปกติ", NONE_FOUND, 120),
    selCol("PK", "pest_insect", "ร่องรอยแมลง", NONE_FOUND, 120),
    textCol("PK", "mat_type", "สารก่อภูมิแพ้", 140),
    textCol("PK", "express_lot", "Express Lot", 130),
    {
      title: "Lot No.",
      dataIndex: "internal_lot",
      width: 170,
      align: "center",
      render: (_, r) => <span>{internalLotDisplay(r)}</span>,
    },
    textCol("PK", "correction", "หมายเหตุ", 150),
    delCol("PK"),
  ];

  return (
    <div className="gr-qc-inspection">
      <Space direction="vertical" size="middle" style={{ display: "flex" }}>
        <Flex justify="space-between" align="center" wrap gap={8}>
          <Typography.Title level={3} className="m-0 !text-zinc-800">
            บันทึกตรวจรับวัตถุดิบ (QC)
            {dirty && (
              <Tag color="orange" style={{ marginLeft: 8, verticalAlign: "middle" }}>
                ยังไม่ได้บันทึก
              </Tag>
            )}
          </Typography.Title>
          <Space>
            <Button icon={<ArrowLeftOutlined />} onClick={handleBack}>
              ย้อนกลับ
            </Button>
            <ButtonAttachFilesGR
              code={grcode}
              size="middle"
              label="แนบไฟล์"
              disabled={!grcode}
              close={refreshCoaStatus}
            />
            <Button
              style={{ borderColor: "#fa8c16", color: "#fff", background: "#fa8c16" }}
              icon={<PrinterOutlined />}
              disabled={!grcode}
              onClick={handlePrint}
            >
              พิมพ์ฟอร์ม
            </Button>
            <Button type="primary" icon={<SaveOutlined />} loading={loading} onClick={handleSave}>
              บันทึกผลตรวจ
            </Button>
          </Space>
        </Flex>

        <Card loading={loading}>
          <Row gutter={[16, 8]}>
            <Col xs={24} sm={8} md={5}>
              <Typography.Text type="secondary">เลขที่ใบรับสินค้า</Typography.Text>
              <div><Tag color="blue">{gr.grcode}</Tag></div>
            </Col>
            <Col xs={24} sm={8} md={5}>
              <Typography.Text type="secondary">ผู้จำหน่าย</Typography.Text>
              <div><strong>{gr.supname}</strong></div>
            </Col>
            <Col xs={24} sm={8} md={5}>
              <Typography.Text type="secondary">วันที่รับวัตถุดิบ</Typography.Text>
              <DatePicker
                format="DD/MM/YYYY" style={{ width: "100%" }}
                value={head.inspect_date}
                onChange={(d) => {
                  setHead((h) => ({ ...h, inspect_date: d }));
                  setDirty(true);
                }}
              />
            </Col>
          </Row>
          <Row gutter={[16, 8]} style={{ marginTop: 12 }}>
            <Col xs={24} sm={8}>
              <Typography.Text type="secondary">Inspector (ผู้ตรวจ)</Typography.Text>
              <Input value={head.inspector} disabled />
            </Col>
            <Col xs={24} sm={8} md={5}>
              {/* วันที่ส่งรายงานผลตรวจ — ไม่กรอกก็ได้ ตอนพิมพ์จะเว้นเส้นประไว้เขียนมือ */}
              <Typography.Text type="secondary">วันที่ส่งรายงาน</Typography.Text>
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="ยังไม่ได้ส่ง"
                value={head.report_sent_date}
                onChange={(d) => {
                  setHead((h) => ({ ...h, report_sent_date: d }));
                  setDirty(true);
                }}
              />
            </Col>
          </Row>
        </Card>

        <div ref={gridRef} onKeyDown={handleGridKeyDown}>
        <Tabs
          type="card"
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            ...(rowsRM.length > 0 ? [{
              key: "rm",
              label: `ตรวจวัตถุดิบ RM (${rowsRM.length})`,
              children: (
                <Card title="รายงานตรวจสอบวัตถุดิบรับเข้า (FM.QA.11/RI)">
                  <Table
                    size="small" rowKey="key" columns={rmColumns} dataSource={rowsRM}
                    pagination={false} scroll={{ x: "max-content" }} bordered
                  />
                </Card>
              ),
            }] : []),
            ...(rowsIG.length > 0 ? [{
              key: "ig",
              label: `ตรวจสารเคมี/ส่วนผสม IG (${rowsIG.length})`,
              children: (
                <Card title="รายงานตรวจสารเคมี-ส่วนผสมรับเข้า (FM.QA.12/RI)">
                  <Table
                    size="small" rowKey="key" columns={igColumns} dataSource={rowsIG}
                    pagination={false} scroll={{ x: "max-content" }} bordered
                  />
                </Card>
              ),
            }] : []),
            ...(rowsCM.length > 0 ? [{
              key: "cm",
              label: `ตรวจสารเคมี CM (${rowsCM.length})`,
              children: (
                <Card title="รายงานตรวจสอบสารเคมีรับเข้า (FM.QA.15/R0)">
                  <Table
                    size="small" rowKey="key" columns={cmColumns} dataSource={rowsCM}
                    pagination={false} scroll={{ x: "max-content" }} bordered
                  />
                </Card>
              ),
            }] : []),
            ...(rowsPK.length > 0 ? [{
              key: "pk",
              label: `รับเข้าภาชนะบรรจุ/บรรจุภัณฑ์ (${rowsPK.length})`,
              children: (
                <Card title="บันทึกการรับเข้าภาชนะบรรจุ/บรรจุภัณฑ์ (FM.WH.13/R1)">
                  <Table
                    size="small" rowKey="key" columns={pkColumns} dataSource={rowsPK}
                    pagination={false} scroll={{ x: "max-content" }} bordered
                  />
                </Card>
              ),
            }] : []),
          ]}
        />
        </div>
      </Space>

      {/* เลือก / เพิ่มหน่วยจากทะเบียนหน่วย (er_unit) — ปุ่ม Create Unit อยู่ในตัว modal */}
      {openUnitModal && (
        <ModalUnit
          show={openUnitModal}
          close={() => {
            setOpenUnitModal(false);
            setUnitTarget(null);
            loadUnits();
          }}
          values={handleUnitChosen}
        />
      )}
    </div>
  );
}
